<template>
    <div class="my-wechat">
        <mt-header fixed title="微信绑定">
            <router-link to="/my" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="wechat-content">
            <div class="wechat-info">
                <div class="wechat-info-avatar">
                    <img :src="userInfo.wechatInfo.headimgurl" />
                    <div class="wechat-name">
                        <p>绑定微信用户：{{ userInfo.wechatInfo.nickname }}</p>
                    </div>
                    <div class="new-form-button">
                        <mt-button size="large" type="primary" @click="updateWechat">解除绑定</mt-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { MessageBox } from 'mint-ui'

    export default{

        data(){
           return {
               userInfo:JSON.parse(window.localStorage.getItem('UserInfo'))
           }
        },
        methods:{
            updateWechat(){

                MessageBox.confirm('解除绑定将退出当前登录用户，确定执行此操作?').then(action => {
                    this.$indicator.open('加载中');

                    this.$axios.post("/my/wechat", {openid:this.userInfo.openid})
                        .then(data => {

                            this.$indicator.close();

                            if (data.data.code === 'OK') {
                                this.$toast('解绑成功!');
                                window.localStorage.removeItem('UserInfo');
                            } else {
                                this.$toast(data.data.message);
                            }
                        });
                });



            }

        }
    }
</script>
<style>
    .wechat-info{
        padding-top:80px;
    }

    .wechat-info-avatar{
       text-align: center;
    }
    .wechat-info-avatar img{
        width:30%;
    }
</style>


// WEBPACK FOOTER //
// src/pages/my/wechat.vue